import ApiService from "@/core/services/api.service";

// Actions
export const FETCH_AI_INVOICES = "fetchAiInvoices";
export const FETCH_AI_INVOICE = "fetchAiInvoice";
export const FIND_AI_INVOICE_BY_ORIGINAL_FILE_NAME =
  "findAiInvoiceByOriginalFileName";
export const UPDATE_AI_INVOICE = "updateAiInvoice";
export const UPDATE_AI_INVOICES_BATCH = "updateAiInvoicesBatch";
export const UPDATE_AI_INVOICE_ROWS = "updateAiInvoiceRows";
export const DELETE_AI_INVOICE = "deleteAiInvoice";
export const UPLOAD_AI_INVOICE_FILE = "uploadAiInvoiceFile";
export const COUNT_AI_INVOICES = "countAiInvoices";
export const COUNT_AI_INVOICES_BY_TYPE = "countAiInvoicesByType";
export const FETCH_AI_INVOICE_TYPES = "fetchAiInvoiceTypes";
export const FETCH_AI_INVOICE_TYPE_BY_SLUG = "fetchAiInvoiceTypeBySlug";
export const SAVE_AI_INVOICE = "storeAiInvoice";
export const MARK_AI_INVOICE_SENT_TO_LYUNIK_STROI =
  "markAiInvoiceSentToLyunikStroi";

// Mutations
export const SET_ERROR = "setError";
export const SET_LOADING = "setLoadingAiInvoice";

const state = {
  errors: [],
  isLoadingAiInvoice: false
};

const getters = {
  isLoadingAiInvoice() {
    return state.isLoadingAiInvoice;
  }
};

const actions = {
  [FETCH_AI_INVOICES](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoices" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_AI_INVOICE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoices", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FIND_AI_INVOICE_BY_ORIGINAL_FILE_NAME](context, originalFileName) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.query("ai-invoices/find-by-original-file-name", {
        original_file_name: originalFileName
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_INVOICE](context, params) {
    context.commit(SET_LOADING, true);

    const id = params.id;

    return new Promise((resolve, reject) => {
      ApiService.update("ai-invoices", id, params.payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_INVOICES_BATCH](context, params) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("ai-invoices/batch-update", params)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPDATE_AI_INVOICE_ROWS](context, params) {
    context.commit(SET_LOADING, true);

    const invoiceId = params.invoiceId;

    return new Promise((resolve, reject) => {
      ApiService.put(`ai-invoices/${invoiceId}/rows`, params.payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_AI_INVOICE](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.delete("ai-invoices", id)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [UPLOAD_AI_INVOICE_FILE](context, formData) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("ai-invoices/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [COUNT_AI_INVOICES](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoices/count")
        .then(({ data }) => {
          resolve(data); // { count: 42 }
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [COUNT_AI_INVOICES_BY_TYPE](context, params = {}) {
    let url = "ai-invoices/count-by-type";
    if (params.slug) {
      url += `?slug=${encodeURIComponent(params.slug)}`;
    }
    return new Promise((resolve, reject) => {
      ApiService.get(url)
        .then(({ data }) => {
          resolve(data); // { count: 42 }
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_AI_INVOICE_TYPES](context) {
    return new Promise((resolve, reject) => {
      ApiService.get("ai-invoices/types")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [FETCH_AI_INVOICE_TYPE_BY_SLUG](context, slug) {
    return new Promise((resolve, reject) => {
      ApiService.get(`ai-invoices/types/${slug}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [SAVE_AI_INVOICE](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("ai-invoices", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [MARK_AI_INVOICE_SENT_TO_LYUNIK_STROI](context, id) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.put(`ai-invoices/mark-sent-to-lyunik-stroi/${id}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_ERROR](state, errors) {
    state.isLoadingAiInvoice = false;
    if (Array.isArray(errors)) {
      state.errors = errors;
    } else {
      state.errors = [errors];
    }
  },
  [SET_LOADING](state, value) {
    state.isLoadingAiInvoice = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
